const gri2021_report_view = {
  namespaced: true,
  state: {
    report_structure: [
      //{
      //    category_id: ,
      //    category_name: ,
      //    category_name_e: ,
      //    topic_id: ,
      //    topic_name: ,
      //    topic_name_e: ,
      //    topic_type: , //일반공개, 특정 주제 공개
      //    topic_type_e: , //Universal Disclosures, Topic-Specific Disclosures
      //    subtopic_code: ,
      //    subtopic_name: ,
      //    subtopic_name_e: ,
      //    gri_code: ,
      //
      //},
    ],
    report_contents_loaded: false,
    active_code: null,

    material_topic_selected_list: []
  },
  mutations: {
    update_material_topic_selected_list(state, res) {
      state.material_topic_selected_list = res;
    },
    update_report_structure(state, new_report_obj) {
      state.report_structure = new_report_obj;
    },
    update_report_contents_loaded(state, new_status) {
      state.report_contents_loaded = new_status;
    },
    update_active_contents_list(state, code) {
      state.active_code = code;
    }
  },
  getters: {
    report_topic_types(state) {
      //[{ topic_type: , topic_type_e:  }]
      const unique_topic_types = [];
      state.report_structure.forEach(item => {
        if (
          unique_topic_types.findIndex(x => {
            return x.topic_type == item.topic_type;
          }) < 0
        ) {
          unique_topic_types.push({ topic_type: item.topic_type, topic_type_e: item.topic_type_e });
        }
      });
      return unique_topic_types;
    },
    report_categories(state) {
      //[{ category_id, category_name, category_name_e }]
      const unique_categories = [];
      state.report_structure.forEach(item => {
        if (
          unique_categories.findIndex(x => {
            return x.category_id == item.category_id;
          }) < 0
        ) {
          unique_categories.push({
            category_id: item.category_id,
            category_name: item.category_name,
            category_name_e: item.category_name_e
          });
        }
      });
      return unique_categories;
    },
    report_topic_specific_categories(state) {
      //[{ category_id, category_name, category_name_e }]
      const unique_categories = [];
      const filtered_structure = state.report_structure.filter(
        item => item.topic_type_e == 'Topic-specific Disclosures'
      );
      filtered_structure.forEach(item => {
        if (
          unique_categories.findIndex(x => {
            return x.category_id == item.category_id;
          }) < 0
        ) {
          unique_categories.push({
            category_id: item.category_id,
            category_name: item.category_name,
            category_name_e: item.category_name_e
          });
        }
      });
      return unique_categories;
    },
    report_universal_categories(state) {
      //[{ category_id, category_name, category_name_e }]
      const unique_categories = [];
      const filtered_structure = state.report_structure.filter(
        item => item.topic_type_e == 'Universal Disclosures'
      );
      filtered_structure.forEach(item => {
        if (
          unique_categories.findIndex(x => {
            return x.category_id == item.category_id;
          }) < 0
        ) {
          unique_categories.push({
            category_id: item.category_id,
            category_name: item.category_name,
            category_name_e: item.category_name_e
          });
        }
      });
      return unique_categories;
    }
  },
  actions: {
    readReportContents({ commit, rootState, dispatch }, { report_code, editor_mode }) {
      commit('update_report_contents_loaded', true); //중복소환 방지
      const path = rootState.backend_host + '/read_report_contents';

      return axios
        .get(path, {
          params: {
            report_code: report_code,
            editor_mode: editor_mode
          }
        })
        .then(response => {
          commit('report_contents/update_report_contents', response.data, { root: true });
          commit('update_report_structure', response.data);
          dispatch(
            'report_contents/newAttachTablesAndDocuments',
            { report_code: report_code },
            { root: true }
          );
        });
    },

    checkTopicIsMaterial({ commit, rootState }, { report_code }) {
      const path = rootState.backend_host + '/check_report_topics_selected_list';

      return axios
        .get(path, {
          params: {
            report_code: report_code
          }
        })
        .then(response => {
          commit('update_material_topic_selected_list', response.data?.result);
        });
    }
  }
};
export default gri2021_report_view;
